module.exports = __webpack_public_path__ + "static/img/our-customers-Industry-row1.431a624.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-Industry-row1.jpg
// module id = fVUH
// module chunks = 0